import { APP_NAME } from '@/constants/app'
import { cn } from '@/utils/cn'

const MARK_SIZE = {
  sm: 'h-10 w-10 rounded-xl text-xs',
  md: 'h-12 w-12 rounded-2xl text-sm',
  lg: 'h-14 w-14 rounded-2xl text-base',
} as const

interface AuthBrandMarkProps {
  size?: keyof typeof MARK_SIZE
  className?: string
}

export function AuthBrandMark({ size = 'md', className }: AuthBrandMarkProps) {
  return (
    <div
      className={cn(
        'mx-auto flex items-center justify-center border border-white/20 bg-white/15 font-bold tracking-tight text-white shadow-md backdrop-blur-sm',
        MARK_SIZE[size],
        className,
      )}
      aria-hidden
    >
      MP
    </div>
  )
}

interface AuthBrandHeaderProps {
  size?: keyof typeof MARK_SIZE
  title?: boolean
  subtitle?: string
  className?: string
}

export function AuthBrandHeader({
  size = 'md',
  title = true,
  subtitle,
  className,
}: AuthBrandHeaderProps) {
  return (
    <div className={cn('text-center', className)}>
      <AuthBrandMark size={size} />
      {title ? (
        <p className="auth-display mt-3 text-lg font-bold tracking-tight text-white sm:text-xl">
          {APP_NAME}
        </p>
      ) : null}
      {subtitle ? (
        <p className="mx-auto mt-2 max-w-xs text-xs leading-relaxed text-slate-200/85 sm:text-sm">
          {subtitle}
        </p>
      ) : null}
    </div>
  )
}

export const AUTH_INPUT =
  'h-11 rounded-xl text-base sm:h-10 sm:text-sm transition-[border-color,box-shadow] duration-200'

export const AUTH_FIELD_ERROR = 'border-destructive focus-visible:ring-destructive/30'
